module.exports = __webpack_public_path__ + "static/media/Checked-green.c7277312.svg";